import { GeoJsonPoint } from '@zoocasa/node-kit/map/types';

export type PointSerializableProperties = ReturnType<typeof Point.prototype.toJSON>;

export class Point implements GeoJsonPoint {
  type: 'Point';
  coordinates: [number, number];

  constructor(point: Record<string, unknown>) {
    this.type = point?.type as 'Point' ?? 'Point';
    this.coordinates = point?.coordinates as [number, number] ?? [0, 0];
  }

  get longitude() {
    return this.coordinates[0];
  }
  get latitude() {
    return this.coordinates[1];
  }

  toJSON() {
    return {
      type: 'Point',
      coordinates: this.coordinates,
    };
  }
}